<template>
  <div class="container exam">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item>阅读资料</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">阅读资料</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="handleToCategory">分类管理</el-button>
          <el-button class="button"
                     type="primary"
                     @click="handleReadCreate">创建专栏</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="题库名称"
                      prop="name">
          <el-input v-model="query.name"
                    placeholder="输入题库名称"
                    @input="fetchReadList(true)"></el-input>
        </el-form-item>
        <el-form-item label="发布人"
                      prop="author">
          <el-input class="author"
                    v-model="query.author"
                    @input="fetchReadList(true)"
                    placeholder="输入发布人昵称/手机号"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="fetchReadList(true)"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="科目"
                      prop="subject">
          <el-input v-model="query.subject"
                    placeholder="请输入科目名称/代码"
                    @input="fetchReadList(true)"></el-input>
        </el-form-item>
        <el-form-item label="状态"
                      prop="status">
          <el-select v-model="query.status"
                     placeholder="请选择"
                     @change="fetchReadList(true)">
            <el-option v-for="item in filter.status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类"
                      prop="category_id">
          <el-select v-model="query.category_id"
                     placeholder="请选择"
                     clearable
                     @change="fetchReadList(true)">
            <el-option v-for="item in $store.state.readCategorys"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学长搜索"
                      prop="name">
          <el-input v-model="query.author"
                    placeholder="输入学长手机号，真实姓名"
                    @input="fetchReadList(true)"
                    style="width: 300px"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="创建人">
          <el-select v-model="query.creator"
                     placeholder="请选择"
                     @change="fetchReadList()"
                     clearable>
            <el-option v-for="item in $store.state.adminList"
                       :key="item.id"
                       :label="item.nickname"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="divider"></div>
      <div class="search-footer">
        <div class="filter-item">
          <span class="label">排序方式</span>
          <div class="values">
            <span :class="
                item.value == query.sort ? 'value-item active' : 'value-item'
              "
                  v-for="item in filter.sorts"
                  :key="item.value"
                  @click="handleFilterChange(item.value, 'sort')">{{ item.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">专栏列表</h3>
        <el-form label-width="70px"
                 size="small">
          <el-form-item style="">
            <el-radio-group v-model="query.status"
                            @change="fetchReadList()">
              <el-badge :value="authNum"
                        class="item"
                        :hidden="authNum == 0"
                        :max="99">
                <el-radio-button v-for="(item, index) in filter.status"
                                 :key="index"
                                 :label="item.value">
                  {{ item.label }}
                </el-radio-button>
              </el-badge>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="tabs">
        <el-tabs v-model="tabName"
                 @tab-click="handleTabChange">
          <el-tab-pane label="全部商品"
                       name="all"></el-tab-pane>
          <el-tab-pane label="学长商品"
                       name="senior"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="values">
        <el-table :data="results"
                  border>
          <el-table-column prop="id"
                           width="80px"
                           label="ID"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column prop="id"
                           label="商品图"
                           width="120px"
                           align="center">
            <template slot-scope="scope">
              <el-image style="height: 50px"
                        :src="scope.row.picture_url"
                        fit="fill"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           width="300"
                           label="商品名称"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="item-table-column">
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="description"
                           label="商品简介"
                           align="center"
                           show-overflow-tooltip
                           width="460">
            <template slot-scope="scope">
              <div class="item-table-column">
                {{ scope.row.description }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           width="120"
                           label="资料分类"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateCategory_id(scope.row.category_id) }}
            </template>
          </el-table-column>
          <el-table-column prop="description"
                           label="关联科目"
                           align="center"
                           show-overflow-tooltip
                           width="230">
            <template slot-scope="scope">
              {{ formatSubject(scope.row.subjects) }}
            </template>
          </el-table-column>
          <el-table-column prop="price"
                           label="售价"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.price > 0">{{
                scope.row.price + "元"
              }}</span>
              <span v-else>免费</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           align="center"
                           width="130">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核状态"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="small"
                      :type="scope.row.audit_status == 1 ? 'success' :scope.row.audit_status  == 0?'':'danger'">{{ scope.row.audit_status  == 1 ? "已通过" : scope.row.audit_status  == 0?'待审核':'已驳回' }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="状态"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="small"
                      :type="scope.row.status == 1 ? 'success' : 'danger'">{{ scope.row.status == 1 ? "上架" : "下架" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="sort"
                           label="排序值"
                           align="center">
          </el-table-column>
          <el-table-column label="学长"
                           width="180"
                           align="center"
                           v-if="query.is_author == 1"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.author">{{ scope.row.author.realname }}/{{
                  scope.row.author.mobile
                }}</span></template>
          </el-table-column>
          <el-table-column prop="name"
                           width="120"
                           label="创建人"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateCreator(scope.row.creator) }}
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           width="180"
                           align="center"
                           v-if="isfixed">
            <template slot-scope="scope">
              <!-- scope.row.audit_status == 0 && -->
              <el-link type="primary"
                       :underline="false"
                       @click="handeCloning(scope.row)">克隆</el-link>

              <el-link v-if="query.status==2"
                       type="warning"
                       :underline="false"
                       @click="handeToAudit(scope.row)">审核</el-link>

              <el-link type="primary"
                       :underline="false"
                       @click="handeToEdit(scope.row)">编辑</el-link>
              <el-link type="danger
            "
                       @click="handleReadRemove(scope.row.id)"
                       :underline="false">删除</el-link>
            </template>
          </el-table-column>
          <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link"> ... </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="c"
                                    style="margin-bottom: 6px"><span @click="handeToEdit(scope.row)"
                          style="font-size: 16px; color: #409eff">
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item command="d"
                                    style="margin-bottom: 6px"><span @click="handleReadRemove(scope.row.id)"
                          style="font-size: 16px; color: #f56c6c">
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>

    <el-dialog title="审核"
               :visible.sync="auditShow"
               width="30%">
      <el-radio-group v-model="auditRadio">
        <el-radio :label="1">通过</el-radio>
        <el-radio :label="-1">驳回</el-radio>
      </el-radio-group>
      <el-form ref="form"
               label-width="70px"
               v-if="auditRadio == -1"
               style="margin-top: 20px">
        <el-form-item label="驳回理由">
          <el-input type="textarea"
                    :rows="2"
                    placeholder="请输入内容"
                    v-model="rejection">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="auditShow = false">取 消</el-button>
        <el-button type="primary"
                   @click="auditSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ReadCard from '@/components/card/Read'
import {
  readList,
  readDestroy,
  readsUpdate,
  auditStatus,
  readClone,
} from '@/api/read'

export default {
  components: {
    ReadCard,
  },
  data() {
    return {
      itmeId: '',
      auditRadio: 1,
      auditShow: false,
      rejection: '',
      query: {
        name: '',
        author: '',
        startTime: '',
        endTime: '',
        subject: '',
        status: '1',
        sort: '1',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      createDatetime: '',
      pageTotal: 10,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '上架', value: '1' },
          { label: '下架', value: '0' },
          { label: '待审核', value: '2' },
        ],
        sorts: [
          { label: '最新', value: '1' },
          { label: '最热', value: '2' },
        ],
      },
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      tabName: '',
      authNum: 0,
    }
  },
  created() {
    this.parseQuery()
    this.fetchReadList()

    this.$store.dispatch('getReadCategorys')
    this.$store.dispatch('getAdminList')
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf()
        this.query.endTime = this.$moment(value[1]).valueOf()
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
  },
  methods: {
    handeCloning(row) {
      this.$confirm('确定要克隆吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          readClone({ id: row.id }).then((res) => {
            this.fetchReadList()
            this.$message.success(`克隆成功!`)
            this.$emit('submit')
          })
        })
        .catch(() => {})
    },

    handeToAudit(row) {
      this.auditRadio = 1
      this.rejection = ''
      this.itmeId = row.id
      this.auditShow = true
    },
    auditSubmit() {
      let data = {}
      if (this.auditRadio == 1) {
        data = {
          id: this.itmeId,
          audit_status: this.auditRadio,
        }
      } else {
        data = {
          id: this.itmeId,
          audit_status: this.auditRadio,
          refuse_reason: this.rejection,
        }
      }
      auditStatus(data).then((res) => {
        this.$message.success('审核成功！')
        this.fetchReadList()
        this.auditShow = false
      })
    },
    // 阅读列表请求
    fetchReadList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      let params = { ...this.query }
      if (this.query.status == 2) {
        params.status = ''
        params.audit_statuses = 0
      }
      readList(params).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
        this.authstrNum()
      })
      this.syncQuery()
    },
    authstrNum() {
      readList({
        audit_statuses: 0,
        isPaging: 0,
      }).then((res) => {
        this.authNum = res.count
      })
    },
    // 检索条件变化
    handleFilterChange(value, type) {
      if (type === 'sort') {
        this.query.sort = value
      }
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchReadList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchReadList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchReadList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      // 手动处理
      this.createDatetime = null
      setTimeout(() => {
        this.fetchReadList()
      }, 20)
    },
    // 阅读资料创建
    handleReadCreate() {
      this.$router.push(`/read/create`)
    },
    // 排序位置变化
    handleSortChange(row, type) {
      const list = this.results
      const index = list.findIndex((v) => v.id == row.id)
      list.splice(index, 1)
      if (type == 'up') {
        list.splice(index - 1, 0, row)
      } else if (type == 'down') {
        list.splice(index + 1, 0, row)
      }
      const rows = list.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      readsUpdate(rows)
        .then((res) => {})
        .catch((error) => {
          this.$message.error('排序更新异常')
          console.log('error: ', error)
        })
    },
    // 阅读资料删除
    handleReadRemove(examId) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          readDestroy({ id: examId }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchReadList()
          })
        })
        .catch(() => {})
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ]
      }
      this.tabName = this.query.is_author == 1 ? 'senior' : 'all'
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    // 分类管理
    handleToCategory() {
      this.$router.push(`/read/category`)
    },
    formatSubject(array) {
      if (array.length) {
        return array
          .map((v) => {
            return v.name
          })
          .join(',')
      } else {
        return '无'
      }
    },
    handeToEdit(row) {
      if (location.host.includes('admin.kaoyanbox.com')) {
        window.open(`https://admin.kaoyanbox.com/read/detail/${row.id}`)
      } else {
        this.$router.push(`/read/detail/${row.id}`)
      }
    },
    formateCategory_id(id) {
      if (
        this.$store.state.readCategorys &&
        this.$store.state.readCategorys.length
      ) {
        if (id) {
          return this.$store.state.readCategorys.find((v) => {
            return v.id == id
          }).name
        } else {
          return '无'
        }
      }
    },
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (
            this.$store.state.adminList.findIndex((v) => {
              return v.id == val
            }) > -1
          ) {
            return this.$store.state.adminList.find((v) => {
              return v.id == val
            }).nickname
          } else {
            return '无'
          }
        } else {
          return '无'
        }
      }
    },
    handleTabChange(tab) {
      if (tab.name == 'senior') {
        this.query.is_author = 1
      } else {
        this.query.is_author = 0
      }
      this.fetchReadList(true)
    },
  },
}
</script>

<style scoped lang="less">
.exam {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .exam-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  margin: 0px 5px;
}
.item-table-column {
  text-align: left;
}
</style>
